export function nextPhotoId(photos) {
  let max = 0;
  photos.forEach((p) => {
    const m = /PH-(\d+)/.exec(p.photo_id || "");
    if (m) max = Math.max(max, parseInt(m[1], 10));
  });
  return `PH-${String(max + 1).padStart(3, "0")}`;
}
